<template>
    <div v-bind:class="cameraCaptureWidgetClass">
        <div v-bind:class="cameraCaptureModeClass" @click="cameraCapture"></div>
        <div v-show="showVideoCaptureTimer" class="capture-timer">{{ this.$store.state.recordingTime }}</div>
    </div>
</template>

<script>
  import { sendViewerMessage, configStatusSubject } from "../webRtcViewer";

  export default {
    name: "CameraCaptureWidget",
    data () {
      return {
      }
    },
    created () {
      // subscribe to config status subject
      this.subscription = configStatusSubject.subscribe({
        next: (configStatus) => {
          // update config status
          if (Object.prototype.hasOwnProperty.call(configStatus, 'cameraStatus')) {
            if (Object.prototype.hasOwnProperty.call(configStatus.cameraStatus, 'cameraMode')) {
              this.$store.commit("setCameraMode", configStatus.cameraStatus.cameraMode);
            }

            if (Object.prototype.hasOwnProperty.call(configStatus.cameraStatus, 'isShootingPhoto')) {
              this.$store.commit("setIsShootingPhoto", configStatus.cameraStatus.isShootingPhoto);
            }
            if (Object.prototype.hasOwnProperty.call(configStatus.cameraStatus, 'canStartShootingPhoto')) {
              this.$store.commit("setCanStartShootingPhoto", configStatus.cameraStatus.canStartShootingPhoto);
            }
            if (Object.prototype.hasOwnProperty.call(configStatus.cameraStatus, 'shootPhotoMode')) {
              this.$store.commit("setShootPhotoMode", configStatus.cameraStatus.shootPhotoMode);
            }
            if (Object.prototype.hasOwnProperty.call(configStatus.cameraStatus, 'isShootingCompleted')) {
              this.$store.commit("setIsShootingCompleted", configStatus.cameraStatus.isShootingCompleted);
            }
            if (Object.prototype.hasOwnProperty.call(configStatus.cameraStatus, 'recordingState')) {
              this.$store.commit("setRecordingState", configStatus.cameraStatus.recordingState);
            }
            if (Object.prototype.hasOwnProperty.call(configStatus.cameraStatus, 'recordingTime')) {
              this.$store.commit("setRecordingTime", configStatus.cameraStatus.recordingTime);
            }
          }
        }
      })
    },
    beforeDestroy() {
      this.subscription.unsubscribe()
    },
    methods: {
      cameraCapture: function () {
        if (this.$store.getters.isCameraModePhoto) {
          this.$store.commit("setIsShootingPhoto", !this.$store.state.isShootingPhoto);
          sendViewerMessage(JSON.stringify({ takePicture: true }))
        } else {
          if (this.$store.getters.isRecording) {
            this.$store.commit("setRecordingState", 'RECORDING_STOPPED');
          } else {
            this.$store.commit("setRecordingState", 'RECORDING_IN_PROGRESS');
          }
          sendViewerMessage(JSON.stringify({ takeVideo: true }))
        }
      },
    },
    computed: {
      cameraCaptureModeClass: function () {
        // todo: this should be moved to ShootPhotoWidget & RecordVideoWidget
        if (this.$store.getters.isCameraModePhoto) {
          if (this.$store.state.isShootingPhoto) {
            return {
              'shoot-photo-circle custom-loader': true
            }
          } else {
            return {
              'shoot-photo-circle': true,
            }
          }
        } else {
          if (this.$store.getters.isRecording) {
            return {
              'shoot-video-circle-in-progress': true
            }
          } else {
            return {
              'shoot-video-circle': true,
            }
          }
        }
      },
      cameraCaptureWidgetClass: function () {
        return {
          'camera-capture-photo-widget': this.$store.getters.isCameraModePhoto,
          'camera-capture-video-widget': !this.$store.getters.isCameraModePhoto,
        }
      },
      showVideoCaptureTimer: function () {
        return this.$store.getters.isRecording;
      }
    },
  }
</script>

<style scoped>
.camera-capture-photo-widget {
    padding: 15%;
}
.camera-capture-video-widget {
    padding: 25%;
}
.shoot-photo-circle {
    border-radius: 50%;
    width: 100%;
    padding-top: 100%;
    background-color: white;
    display: block;
    border: 0.13vw solid black;
    box-shadow: 0 0 0 0.1vw white;
}
.shoot-video-circle {
    border-radius: 50%;
    width: 100%;
    padding-top: 100%;
    background-color: red;
    display: block;
    border: 0.13vw solid black;
    box-shadow: 0 0 0 0.1vw white;
}
.shoot-video-circle-in-progress {
    border-radius: 25%;
    width: 100%;
    padding-top: 100%;
    background-color: red;
    display: block;
    border: 0.13vw solid black;
    box-shadow: 0 0 0 0.1vw white;
}
.capture-timer {
    color: white;
    text-align: center;
    margin-top: 0.2vw;
    font-size: 0.7vw;
    font-weight: bold;
}
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .capture-timer {
        font-size: 1.7vw;
    }
}
.custom-loader {
  -webkit-transition-property: -webkit-transform;
  -webkit-transition-duration: 1.2s;
  -webkit-animation-name: rotate;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;

  -moz-transition-property: -moz-transform;
  -moz-animation-name: rotate;
  -moz-animation-duration: 1.2s;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;

  transition-property: transform;
  animation-name: rotate;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@-webkit-keyframes rotate {
    from {-webkit-transform: rotate(0deg);}
    to {-webkit-transform: rotate(360deg);}
}

@-moz-keyframes rotate {
    from {-moz-transform: rotate(0deg);}
    to {-moz-transform: rotate(360deg);}
}

@keyframes rotate {
    from {transform: rotate(0deg);}
    to {transform: rotate(360deg);}
}
</style>
